import React, { useEffect } from 'react';
import styled from 'styled-components';
import { colors, layout } from 'Constants';

import { Container, Header, Icon, Anchor, Button } from 'Components/core';
import { Subscribe } from 'laco-react';
import { ApiStore } from 'Store';
import InfoBox from 'Components/InfoBox';
import ReadyToEnroll from 'Views/benefits/components/ReadyToEnroll';

import CardHighlighted from 'Components/Card/CardHighlighted';

// Images
import WhatYourPlanCovers from './images/pharmacy_hero@2x.png';
import HowYourPharmacyBenefitsWork from './images/Pharmacy_Benefits_-_How_your_pharmacy_benefits_work.jpeg';
import HowToSaveMoney from './images/Pharmacy_Benefits_-_How_to_save_money_on_medicine.jpeg';
import CODES from 'Root/libs/analytics/CodeDef';
import Api from 'Root/libs/analytics/Api';
import { replaceAnchor } from 'Root/libs/anchor';
import { HeaderV2, SubHeader, TitleHeader } from 'Components/core/Header';
import MedBox from './images/medbox.svg';

const payDeductible_list = ['ded', 'dedComb', 'dedNo', 'dedMult'];
const preventiveDrugs_list = [
  'SpecPrev1',
  'SpecPrev2',
  'SpecPrev3',
  'SpecPrev4'
];
const shareCosts_list = ['share1', 'share2', 'share3'];

export default () => {
  useEffect(() => {
    Api.recordAcitity(CODES.MENU_PHARMACY_BENIFITS);
  }, []);

  return (
    <Subscribe to={[ApiStore]}>
      {state => (
        <Container
          seperation="24px"
          column
          maxWidth
          style={{ paddingBottom: 60, margin: 'auto' }}
        >
          <HeaderV2 title={'Pharmacy Benefits'} text={<> </>}></HeaderV2>

          <InfoBox
            header="What Your Plan Covers"
            longText={
              state.pharmacy?.summary ? (
                <span
                  dangerouslySetInnerHTML={{
                    __html: replaceAnchor(state.pharmacy?.summary)
                  }}
                ></span>
              ) : (
                <span>
                  Getting the medicine you need is important for your health,
                  whether you take a drug every day or only once in a while. Be
                  sure to check the drug lists for your medicines to be sure
                  they’re covered. This will help you save the most money.
                </span>
              )
            }
            image={WhatYourPlanCovers}
          >
            {state?.pharmacy?.yourPlanCovers && (
              <p
                dangerouslySetInnerHTML={{
                  __html: replaceAnchor(state?.pharmacy?.yourPlanCovers)
                }}
              ></p>
            )}

{state?.pharmacy?.coverageRequirements && (
              <p
                dangerouslySetInnerHTML={{
                  __html: replaceAnchor(state?.pharmacy?.coverageRequirements)
                }}
              ></p>
            )}

            {state?.pharmacy?.understandingPharmacyBenefits && (
              <p
                dangerouslySetInnerHTML={{
                  __html: replaceAnchor(
                    state?.pharmacy?.understandingPharmacyBenefits
                  )
                }}
              ></p>
            )}

{state?.pharmacy?.underStandingBenefits && (
              <p
                dangerouslySetInnerHTML={{
                  __html: replaceAnchor(
                    state?.pharmacy?.underStandingBenefits
                  )
                }}
              ></p>
            )}
              {state?.pharmacy?.pharmacyOptions && (
              <p
                dangerouslySetInnerHTML={{
                  __html: replaceAnchor(state?.pharmacy?.pharmacyOptions)
                }}
              ></p>
            )}
                {state?.pharmacy?.NinetyDaySupply && (
              <p
                dangerouslySetInnerHTML={{
                  __html: replaceAnchor(state?.pharmacy?.NinetyDaySupply)
                }}
              ></p>
            )}
         
          
        
            {state?.pharmacy?.RxNinetyDaySupply && (
              <p
                dangerouslySetInnerHTML={{
                  __html: replaceAnchor(state?.pharmacy?.RxNinetyDaySupply)
                }}
              ></p>
            )}

            
         
         {state?.pharmacy?.benefitsAndDeductible && (
              <p
                dangerouslySetInnerHTML={{
                  __html: replaceAnchor(state?.pharmacy?.benefitsAndDeductible)
                }}
              ></p>
            )}
           
           {state?.pharmacy?.reviewDrugList && (
              <p
                dangerouslySetInnerHTML={{
                  __html: replaceAnchor(state?.pharmacy?.reviewDrugList)
                }}
              ></p>
            )}
         
            {!state?.pharmacy?.yourPlanCovers && (
              <p>
                <b>Your plan includes:</b>
                <ul>
                  {state?.pharmacy?.drugList?.link?.length > 0 && (
                    <li>
                      <div>
                        Your plan includes medicine on the following drug
                        list(s) including brand name and generic drugs:
                        <ul>
                          {state?.pharmacy?.drugList?.link?.map(drug => {
                            return (
                              <li>
                                <Anchor
                                  style={{ textDecoration: 'underline' }}
                                  code={CODES.PH_BFT_DRUG_LIST}
                                  to={drug.url}
                                  target="_new"
                                >
                                  {drug.label}
                                </Anchor>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </li>
                  )}

                  <ul></ul>
                  {preventiveDrugs_list.indexOf(
                    state?.pharmacy?.preventiveDrugs
                  ) == -1 &&
                    state?.pharmacy?.preventiveDrugs && (
                      <li
                        dangerouslySetInnerHTML={{
                          __html: replaceAnchor(
                            state?.pharmacy?.preventiveDrugs
                          )
                        }}
                      ></li>
                    )}
                  {preventiveDrugs_list.indexOf(
                    state?.pharmacy?.preventiveDrugs
                  ) != -1 && (
                    <React.Fragment>
                      {state?.pharmacy?.preventiveDrugs == 'SpecPrev1' && (
                        <li>
                          You also have access to:
                          <br />
                          <ul>
                            <li>
                              68,000 pharmacies across the country plus an easy
                              home delivery option.
                            </li>
                            <li>
                              Most specialty drugs if you have an ongoing health
                              issue or serious illness. Look for "SP" or the
                              Specialty Pharmacy icon when viewing your plan's
                              drug list.
                            </li>
                            <li>
                              Some preventive drugs at little or no cost to you.
                            </li>
                          </ul>
                        </li>
                      )}
                      {state?.pharmacy?.preventiveDrugs == 'SpecPrev2' && (
                        <li>
                          You also have access to:
                          <ul>
                            <li>
                              68,000 pharmacies across the country plus an easy
                              home delivery option.
                            </li>
                            <li>
                              Some preventive drugs at little or no cost to you.
                            </li>
                          </ul>
                        </li>
                      )}
                      {state?.pharmacy?.preventiveDrugs == 'SpecPrev3' && (
                        <li>
                          You also have access to:
                          <ul>
                            <li>
                              68,000 pharmacies across the country plus an easy
                              home delivery option.
                            </li>
                            <li>
                              Most specialty drugs if you have an ongoing health
                              issue or serious illness. Look for "SP" or the
                              Specialty Pharmacy icon when viewing your plan's
                              drug list.
                            </li>
                          </ul>
                        </li>
                      )}

                      {state?.pharmacy?.preventiveDrugs == 'SpecPrev4' && (
                        <li>
                          You also have access to 68,000 pharmacies across the
                          country plus an easy home delivery option.
                        </li>
                      )}
                    </React.Fragment>
                  )}

                  {state?.pharmacy?.specialtyDrugs && (
                    <li
                      dangerouslySetInnerHTML={{
                        __html: replaceAnchor(state?.pharmacy?.specialtyDrugs)
                      }}
                    ></li>
                  )}
                  {state?.pharmacy?.accessPharmacies && (
                    <li
                      dangerouslySetInnerHTML={{
                        __html: replaceAnchor(state?.pharmacy?.accessPharmacies)
                      }}
                    ></li>
                  )}
                </ul>
              </p>
            )}

            {state?.pharmacy?.netWorks?.network && (
              <div>
                <DivContainer>
                  {convertToArray(state?.pharmacy?.netWorks.network).map(network => {
                    return (
                      <InnerDiv>
                        <b>{network.name}</b>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: replaceAnchor(network.summary)
                          }}
                        ></p>
                      </InnerDiv>
                    );
                  })}
                </DivContainer>
              </div>
            )}
          </InfoBox>
          {state?.pharmacy?.payDeductible && state?.pharmacy?.shareCosts && (
            <PharamacyBenefits state={state} />
          )}

          <Container column image={HowToSaveMoney}>
            <TitleHeader style={{ display: 'block', textAlign: 'center' }}>
            How to Save Money on Medicine
            </TitleHeader>
            <p style={{ textAlign: 'center' }}>
              Your plan comes with handy tools to help you get the best care and
              save money
            </p>
            <CardContainer style={{ justifyContent: 'space-around' }}>
              <Card>
                <CardIcon size="2x">1</CardIcon>
                <p>
                  <b>Search the drug list. </b>
                  <br />
                  Prescription medicines or drugs are listed in groups called
                  tiers. Lower-cost drugs and generics are usually Tiers 1 and
                  2.
                </p>
              </Card>
              <Card>
                <CardIcon size="2x">2</CardIcon>
                <p>
                  <b>Price a medication </b>
                  <br />
                  Once you become a member, you can compare retail drug costs at
                  local pharmacies at{' '}
                  <Anchor
                    code={CODES.PH_BFT_SITE_BROWSE}
                    to={state.brandInfo.webLink}
                    target="_blank"
                  >
                    {state.brandInfo.website}.
                  </Anchor>
                </p>
              </Card>
              <Card>
                <CardIcon size="2x">3</CardIcon>
                <p>
                  <b>Use a pharmacy in your plan. </b> <br />
                  Be sure to use a pharmacy in your plan – you’ll save money.
                </p>
              </Card>

              <Card>
                <CardIcon size="2x">4</CardIcon>
                <p>
                  <b>
                    Ask your doctor about generic or over-the-counter options.
                  </b>
                  <br />
                </p>
              </Card>
              {state?.pharmacy?.pharmacyHomeDelivery == true && (
                <Card>
                  <Icon size="2x">5</Icon>
                  {/* TODO: Take a look at this section as the PDF has tags */}
                  <p>
                    <b>Sign up for home delivery </b> and get up to a 90-day
                    supply delivered right to your door.
                  </p>
                </Card>
              )}
            </CardContainer>

            {state?.pharmacy?.pharmacyASO == true && (
              <Card>
                <b style={{ textAlign: 'left' }}>
                  {' '}
                  Save Money on non-covered medication{' '}
                </b>
                <p style={{ textAlign: 'left' }}>
                  Save money on some non-covered medications. If your
                  prescription isn’t covered by your plan, you may be able to
                  get a discount. Share your ID card at the pharmacy and the
                  available discount will automatically be applied.
                </p>
              </Card>
            )}
          </Container>
          <Container justifyContent="center" style={{ marginTop: 40 }}>
            {state?.pharmacy?.pharmacyFAQURL == true && (
              <CardHighlighted>
                <Header>Questions? </Header>
                <p style={{ textAlign: 'center' }}>
                  Call the Pharmacy Member Services phone number on your member
                  ID Card – we're available 24/7.
                </p>
              </CardHighlighted>
            )}
          </Container>

          {false && <ReadyToEnroll />}
        </Container>
      )}
    </Subscribe>
  );
};

const CardIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 0px 0px 8px 8px;
  background: #286ce2;
  font-family: 'Elevance Sans Regular';
  font-weight: 500;
  font-size: 36px;
  line-height: 48px;
  text-align: center;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PharamacyBenefitsContainer = styled.div`
  background: #e1edff;
  display: flex;
  padding: 60px;
  padding-bottom: 120px;
  flex-wrap: wrap;
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    padding: 10px;
  }
`;

const PharamacyBenefitsRight = styled.div`
  flex: 3;
`;
const PharamacyBenefitsLeft = styled.div`
  flex: 2;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PharmacyBenefitsCard = styled.div`
  background: #fff;

  border-radius: 8px;
  background: #fff;
  border: 1px solid #ccc;
  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.08);
  padding: 20px;
  margin-top: 30px;
  width: 100%;

  font-family: 'Elevance Sans Regular';
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  text-align: left;
  color: #131331;

  > b {
    font-family: 'Elevance Sans semibold';
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    text-align: left;
    color: #333;
  }
`;

const PharamacyBenefitsCardHolder = styled.div`
  max-width: 552px;
`;

const PharmacyImage = styled.img`
  width: 287px;
  height: auto;
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    width: 50vw%;
    height: auto;
  }
`;

const PharamacyBenefits = ({ state }) => {
  return (
    <PharamacyBenefitsContainer>
      <PharamacyBenefitsLeft>
        <PharmacyImage src={MedBox} />
      </PharamacyBenefitsLeft>
      <PharamacyBenefitsRight>
        <PharamacyBenefitsCardHolder>
          <TitleHeader style={{ textAlign: 'center', display: 'block' }}>
            How your pharmacy benefits work
          </TitleHeader>
          {payDeductible_list.indexOf(state?.pharmacy?.payDeductible) == -1 &&
            state?.pharmacy?.payDeductible && (
              <PharmacyBenefitsCard
                dangerouslySetInnerHTML={{
                  __html: replaceAnchor(state?.pharmacy?.payDeductible)
                }}
              ></PharmacyBenefitsCard>
            )}
          {payDeductible_list.indexOf(state?.pharmacy?.payDeductible) != -1 &&
            state?.pharmacy?.payDeductible && (
              <React.Fragment>
                {state?.pharmacy?.payDeductible == 'ded' && (
                  <PharmacyBenefitsCard>
                    Your plan comes with a pharmacy deductible, which is
                    separate from your medical deductible. That means you’ll pay
                    a set amount of drug costs out of your pocket before your
                    plan starts to share the cost of your covered medicine
                  </PharmacyBenefitsCard>
                )}
                {state?.pharmacy?.payDeductible == 'dedComb' && (
                  <PharmacyBenefitsCard>
                    Your plan comes with a combined medical and pharmacy
                    deductible. That means you’ll have to pay the full cost for
                    your covered drugs until you meet 100% of your annual
                    deductible. The cost you pay out of your pocket for covered
                    drugs and covered medical care will go towards meeting your
                    annual deductible. Your plan will start to share the cost of
                    your covered medicine and covered medical care after you
                    reach your deductible
                  </PharmacyBenefitsCard>
                )}
                {state?.pharmacy?.payDeductible == 'dedNo' && (
                  <PharmacyBenefitsCard>
                    Your plan doesn't require a pharmacy deductible. That means
                    your plan helps pay for medicine before you reach your
                    deductible
                  </PharmacyBenefitsCard>
                )}
                {state?.pharmacy?.payDeductible == 'dedMult' && (
                  <PharmacyBenefitsCard>
                    Before a plan starts to help pay for medicine, you may first
                    pay a set amount out of your pocket. This is your
                    deductible. You’ll want to check the plan details to see if
                    it has a: <br />
                    <br />
                    Pharmacy deductible: You first pay a set amount of drug
                    costs out of your pocket and it’s separate from a medical
                    deductible. You have to pay your full pharmacy deductible
                    before your plan starts to share the cost of your medicine.
                    <br />
                    <br />
                    Combined deductible: You first pay a set amount for both
                    covered medical care and drug costs out of your pocket.{' '}
                    <br />
                    <br />
                    No pharmacy deductible: Your plan helps pay for medicine
                    before you reach your deductible.
                  </PharmacyBenefitsCard>
                )}
              </React.Fragment>
            )}
          {shareCosts_list.indexOf(state?.pharmacy?.shareCosts) == -1 && (
            <PharmacyBenefitsCard
              dangerouslySetInnerHTML={{
                __html: replaceAnchor(state?.pharmacy?.shareCosts)
              }}
            ></PharmacyBenefitsCard>
          )}
          {shareCosts_list.indexOf(state?.pharmacy?.shareCosts) != -1 && (
            <PharmacyBenefitsCard>
              {state?.pharmacy?.shareCosts == 'share1' && (
                <p>
                  You pay a set amount, or copay, for medicine. Your copay will
                  be based on which tier the drug is on.
                </p>
              )}
              {state?.pharmacy?.shareCosts == 'share2' && (
                <p>
                  You pay a certain percentage of the drug’s cost, which can be
                  different based on the pharmacy you use
                </p>
              )}

              {state?.pharmacy?.shareCosts == 'share3' && (
                <p>
                  {' '}
                  After you meet your deductible, your plan will share the cost
                  of medicine. Your options include plans with different ways of
                  sharing the cost:
                  <CardContainer>
                    <Card>
                      <Header>Copay</Header>
                      <p>
                        You pay a set amount, or copay, for medicine. Your copay
                        will be based on which tier the drug is on.
                      </p>
                    </Card>
                    <Card>
                      <Header>Coinsurance</Header>
                      <p>
                        You pay a certain percentage of the drug’s cost, which
                        can be different based on the pharmacy you use.
                      </p>
                    </Card>
                  </CardContainer>
                </p>
              )}
            </PharmacyBenefitsCard>
          )}
        </PharamacyBenefitsCardHolder>
      </PharamacyBenefitsRight>
    </PharamacyBenefitsContainer>
  );
};

const CardContainer = styled(Container).attrs(props => ({
  border: typeof props.border === 'boolean' ? props.border : true
}))`
  > * {
  }

  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    flex-direction: column;

    > * {
      flex-basis: auto;
    }

    > * + * {
    }
  }
`;

const Card = styled.div`
  background-color: red;

  width: 264px;
  height: 270px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #ccc;
  padding: 20px;
  padding-top: 0px;
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    width: auto;
    margin-right: 10px;
    margin-left: 10px;
    margin-bottom: 10px;
  }

  > p {
    margin-top: 10px;
  }
`;

const InnerDiv = styled.div`
  margin-top: 20px;

  height: auto;

  border-radius: 8px;
  background: #fff;
  /**
  border: 1px solid #ccc; */
  padding: 20px;

  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    width: auto;

    margin-right: 10px;
    margin-left: 10px;
  }
  /*
  > b {
    font-family: 'Elevance Sans Semibold';
    font-weight: 600;
    font-size: 23px;
    line-height: 35px;
    text-align: left;
    color: #333;
    margin-bottom: 15px;
  }
    */
`;

const DivContainer = styled.div`
  margin-bottom: 20px;

  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    display: block;
  }
`;


function convertToArray(val) {
  if(!val)
    return [];
  if (!Array.isArray(val) && typeof val === 'object') return [val];
  return val;
}
